import { useForm } from "react-hook-form";
import { FormInput } from "../../shared/formElements/formInput/FormInput";
import { FormCheckboxChips } from "../../shared/formElements/formCheckBoxChip/FormCheckBoxChip";
import { formatDate } from "../../../utils/formatNumber";
import classes from "./cancellationDetailForm.module.css";
import { FormTextarea } from "../../shared/formElements/formTextarea/FormTextarea";

const CancellationStatus = [
  { id: 13, label: "Approve" },
  { id: 20, label: "Reject" },
];

export const CancellationDetailForm = ({
  initialValues,
  onSubmit,
  isSubmitting,
}) => {
  const { register, watch, setValue, handleSubmit } = useForm({
    defaultValues: {
      order_status: initialValues.order_status ?? "",
      remarks: initialValues.remarks ?? "", // ⬅️ comes from backend
    },
  });

  // Watch form values
  const orderStatus = watch("order_status");
  const isDisabled =
    initialValues.order_status_label !== "Cancellation Requested";

  // Submit handler
  const handleFormSubmit = (data) => {
    const payload = {
      order_id: initialValues.id,
      order_status: Number(data.order_status),

      // remarks optional
      ...(data.remarks?.trim() ? { remarks: data.remarks.trim() } : {}),
    };

    console.log("Form submitted payload:", payload);
    onSubmit(payload);
  };

  return (
    <form className={classes.form} onSubmit={handleSubmit(handleFormSubmit)}>
      <div className={classes.columnsWrapper}>
        {/* LEFT SECTION */}
        <div className={classes.section}>
          <div className={classes.grid}>
            <FormInput label="Request ID" value={initialValues.id} readOnly />

            <FormInput
              label="Ordered On"
              value={formatDate(initialValues.ordered_on)}
              readOnly
            />

            <FormInput
              label="Postal Code"
              value={initialValues.postal_code}
              readOnly
            />

            <FormInput
              label="Total Amount"
              value={initialValues.total_amount}
              readOnly
            />

            <FormCheckboxChips
              id="order_status"
              label="Status"
              options={CancellationStatus}
              watch={watch}
              setValue={setValue}
              register={register}
              disabled={isDisabled}
            />
          </div>

          <FormTextarea
            id="remarks"
            label="Remarks"
            register={register}
            placeholder="Add remarks (optional)"
          />
        </div>
      </div>

      {/* ---------- ACTIONS ---------- */}
      <div className={classes.actions}>
        <button
          type="submit"
          className={classes.submitBtn}
          disabled={isSubmitting || !orderStatus || isDisabled}
        >
          {isSubmitting ? "Updating..." : "Update Order"}
        </button>
      </div>
    </form>
  );
};
